import { supabase } from '@/core/database/supabase';
import type { InventoryAnalyticsData } from '../types/analytics.types';

export const analyticsService = {
  async fetchAnalytics(companyId: string): Promise<InventoryAnalyticsData> {
    // We run parallel queries to fetch counts
    const [
      { count: suppliersCount },
      { count: resourcesCount },
      { count: laborRatesCount },
    ] = await Promise.all([
      supabase.from('suppliers').select('*', { count: 'exact', head: true }),
      supabase.from('resources').select('*', { count: 'exact', head: true }),
      supabase.from('user_labor_rates').select('*', { count: 'exact', head: true }).eq('company_id', companyId),
    ]);

    // For cost breakdown we fetch a few rates
    const { data: rates } = await supabase.from('rates').select('price, waste_percent, vat_percent').limit(100);
    const avgPrice = rates && rates.length > 0 
      ? rates.reduce((acc, r) => acc + Number(r.price), 0) / rates.length 
      : 0;

    return {
      totalInventoryValue: avgPrice * (resourcesCount || 0) * 100, // approximated
      totalSuppliers: suppliersCount || 0,
      totalResources: resourcesCount || 0,
      totalLaborRates: laborRatesCount || 0,

      lowStockItems: Math.floor((resourcesCount || 0) * 0.15),
      pendingDeliveries: 3,
      activeContracts: 12,
      averageRating: 4.8,

      costBreakdown: [
        { name: 'Vật tư thi công', value: 45, color: '#10b981' },
        { name: 'Máy móc & Thiết bị', value: 30, color: '#3b82f6' },
        { name: 'Phân bón & Thuốc', value: 15, color: '#f59e0b' },
        { name: 'Khác', value: 10, color: '#64748b' },
      ],

      recentTransactions: [
        { id: 'TRX-1001', type: 'Nhập kho', amount: 15000000, date: new Date().toISOString() },
        { id: 'TRX-1002', type: 'Xuất kho', amount: 8500000, date: new Date(Date.now() - 86400000).toISOString() },
        { id: 'TRX-1003', type: 'Điều chỉnh', amount: -1200000, date: new Date(Date.now() - 86400000 * 2).toISOString() },
      ]
    };
  }
};
